import ClusterCriticality from "./ClusterCriticality"

export default Object.freeze({
    [ClusterCriticality.BASIC] : 'Development',
    [ClusterCriticality.STABLE] :'Stable',
    [ClusterCriticality.MISSION_CRITICAL] : 'Production',
})
